<template>
	<v-card class="elevation-3 mb-3" color="white">
		<v-card-title class="secondary--text">
			<v-spacer></v-spacer>

			<v-icon color="secondary" @click="closeAvailabilitySet()">mdi-close</v-icon>
		</v-card-title>
		<v-row no-gutters>
			<v-col>
				<div align="center" justify="center">
					<v-avatar color="white" size="100">
						<img class="white--text" height="10" :src="require('@/assets/icons/✅.svg')" />
					</v-avatar>
				</div>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<h3 color="primary--text" class="title font-weight-bold" align="center" justify="center">Set another</h3>
			</v-col>
		</v-row>

		<v-row no-gutters align="center" justify="center">
			<v-col align="center" justify="center">
				<v-btn align="center" rounded class="subtitle primary--text font-weight-bold" justify="center" @click="locumGotoSetAvailability()"
					>Set Availability <v-icon right>mdi-arrow-right</v-icon></v-btn
				>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import { bus } from '@/main';
export default {
	name: 'LocumAvailabilitySet',
	components: {},
	data: () => ({}),
	methods: {
		created() {
			//check if authenticated ?
		},
		locumGotoSetAvailability() {
			this.$emit('dismiss', this);
			window.scrollTo(0, 0);
			bus.$emit('change-context', 'locum-set-availability');
		},

		closeAvailabilitySet() {
			// this.$emit("change-context", "locum-dashboard-landing-zone");
			this.$emit('dismiss', this);
		},
	},
};
</script>
